/**
 * @generated SignedSource<<2e5003716d58d26276e4582389147bfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ImportQuickbooksCustomersInput = {
  qboCustomers?: ReadonlyArray<QuickbooksCustomerInput | null> | null;
  resolutions?: ReadonlyArray<QuickbooksClientMatchResolution> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type QuickbooksCustomerInput = {
  id?: string | null;
  realmId?: string | null;
};
export type QuickbooksClientMatchResolution = {
  customerId: string;
  realmId: string;
  clientId: number;
};
export type ImportQuickbooksCustomersMutation$variables = {
  input: ImportQuickbooksCustomersInput;
};
export type ImportQuickbooksCustomersMutation$data = {
  readonly importQuickbooksCustomers: {
    readonly company: {
      readonly clients: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string;
            readonly notes: string | null;
            readonly logoId: string | null;
            readonly logoDefaultId: number | null;
            readonly projectCount: number | null;
            readonly xeroContactId: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type ImportQuickbooksCustomersMutation = {
  variables: ImportQuickbooksCustomersMutation$variables;
  response: ImportQuickbooksCustomersMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10000
    }
  ],
  "concreteType": "ClientTypeConnection",
  "kind": "LinkedField",
  "name": "clients",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Client",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "notes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoDefaultId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "projectCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "xeroContactId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "clients(first:10000)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportQuickbooksCustomersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ImportQuickbooksCustomersPayload",
        "kind": "LinkedField",
        "name": "importQuickbooksCustomers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportQuickbooksCustomersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ImportQuickbooksCustomersPayload",
        "kind": "LinkedField",
        "name": "importQuickbooksCustomers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "81198f67545dd115d9ae5d48c5e64c58",
    "id": null,
    "metadata": {},
    "name": "ImportQuickbooksCustomersMutation",
    "operationKind": "mutation",
    "text": "mutation ImportQuickbooksCustomersMutation(\n  $input: ImportQuickbooksCustomersInput!\n) {\n  importQuickbooksCustomers(input: $input) {\n    company {\n      clients(first: 10000) {\n        edges {\n          node {\n            id\n            name\n            notes\n            logoId\n            logoDefaultId\n            projectCount\n            xeroContactId\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6979649c261ddb1009d35a9aafcff0db";

export default node;
